import React, {ReactNode} from 'react';
import styles from './ModuleItemWrapper.module.css';
import LayoutContentWrapper from "../../../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";


interface IProps {
    children: ReactNode
}

const ModuleItemWrapper = ({children}: IProps) => {
    return (
        <div>
            <LayoutContentWrapper>
                <div className={styles.moduleWrapper}>
                    {children}
                </div>
            </LayoutContentWrapper>
        </div>
    );
};

export default ModuleItemWrapper;